import Container from "../layout/Container";
import LeadForm from "./LeadForm";
import HeroImg from "../../assets/fetus-hero.webp";

export default function FetusHero() {
  return (
    <section id="fetus" className="bg-white">
      <Container className="grid gap-8 py-24 lg:grid-cols-2 items-stretch">
        <div className="space-y-4 flex flex-col">
          <p className="inline-flex w-fit rounded-full bg-secondary/5 px-3 py-1 font-semibold text-secondary">
            굿리치 플러스 | 태아보험
          </p>

          <h1 className="text-4xl font-extrabold leading-tight text-secondary md:text-4xl">
            태아보험으로 출생이후 보장
            <br />
            출산 전부터 든든하게 준비
          </h1>

          <p className="text-gray-600 text-lg">
            우리 아이에게 필요한 보장 구성과 보험료를 간편하게 확인해보세요.
          </p>

          <div className="relative h-[400px] min-h-[400px] max-h-[400px] shrink-0">
            <img
              src={HeroImg}
              alt="태아보험 사진"
              className="h-full w-full rounded-2xl object-cover"
            />
          </div>
        </div>

        <div className="h-full flex">
          <div className="w-full h-full">
            <div className="h-full rounded-2xl border bg-white p-5 shadow-sm flex flex-col justify-center">
              <LeadForm type="FETUS" />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
